import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class NoticiaService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  listarRecente() {
    try {
      return new Promise(async (resolve) => {
        this.http
          .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Noticia/listarRecentes',
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {},
          );
      });
    } catch (error) {
      alert(error);
    }
  }

  downloadVideo(url) {
    try {
      return new Promise(async (resolve) => {
        this.http
          .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/youtube/baixar?url=' +
              url,
            { responseType: 'blob' },
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {},
          );
      });
    } catch (error) {
      alert(error);
    }
  }

  obter(id) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Noticia/Obter?Id=' +
            id,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarPorProjeto(idProjetoLista, processId = '') {
    try {
      return new Promise(async (resolve) => {
        this.http
          .post(
            `https://project-5082f113-c983-477a-973.uw.r.appspot.com/Noticia/ListarPorProjetoLei?processId=${processId}`,
            idProjetoLista,
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {},
          );
      });
    } catch (error) {
      alert(error);
    }
  }
}
